// LoadingManager.js
var LoadingManager = pc.createScript('loadingManager');

LoadingManager.attributes.add('progressImage', {type: 'entity'});
LoadingManager.attributes.add('progressImageMaxWidth', {type: 'number'});


LoadingManager.prototype.initialize = function() {

    LoadingManager.instance = this;
};

LoadingManager.prototype.setProgress = function (value) {    

    value = pc.math.clamp(value, 0, 1);

    this.progress = value;
    
    var width = pc.math.lerp(0, this.progressImageMaxWidth, value);

    this.progressImage.element.width = width;
    
};

